import { get, post } from '@/api/request'
import { services, utilities } from '@billow/js-helpers'

export default {

  login: (user, success, failure) => post(
    '/oauth/token',
    services.auth.passportLoginPayload(user),
    success, failure
  ),
  
  signup: (user, success, failure) => post(
    '/api/signup',
    user, success, failure
  ),

  loadUser: (success, failure) => get(
    `/api/user`,
    success, failure
  ),

  requestPasswordReset: (payload, success, failure) => post(
    '/api/security/password-reset/request',
    payload, success, failure
  ),

  resetPassword: (payload, success, failure) => post(
    '/security/password-reset/reset',
    payload, success, failure
  ),

  changePassword: (payload, success, failure) => post(
    '/security/user/password',
    payload, success, failure
  ),
  
  saveProfile: (payload, success, failure) => post(
    '/user-profile',
    payload, success, failure
  ),

  uploadProfilePicture: (payload, success, failure) => post(
    '/profile-picture',
    utilities.formData({ picture: payload.picture }),
    success, failure
  ),

  update: (user, success, failure) => post(
    '/auth/user', user, success, failure
  ),
}
